import type { Order, UnderlyingAsset } from 'state';
import { BUY } from 'state';
import { formatters } from 'services';

const MISSING_COUNTRY_CODES = new Set(['n/a', 'none', 'null']);

/** Mirrors the Markets V5 country + persisted initial-tenor bond identity. */
export const v5BlotterAssetLabel = (asset: UnderlyingAsset): string => {
  if (!asset.resourcetype.endsWith('Bond')) return asset.ticker;

  const fallback = asset.name || asset.ticker;
  const countryCode = asset.country_code?.trim();
  const initialTenor = asset.initial_tenor_years;
  const countryCodeIsMissing =
    !countryCode || MISSING_COUNTRY_CODES.has(countryCode.toLowerCase());

  if (countryCodeIsMissing || initialTenor == null) return fallback;
  return `${countryCode}${formatters.commas1Digit(initialTenor)}Y`;
};

/** Simplified options deliberately use only Buy/Sell, never action/effect copy. */
export const v5TransactionLabel = (
  order: Pick<Order, 'transaction'>,
  isSimplifiedOption: boolean,
) => {
  if (isSimplifiedOption) return order.transaction === BUY ? 'Buy' : 'Sell';
  return undefined;
};

export const orderEventTimestamp = (order: Order): string =>
  order.executed_at || order.canceled_at || order.timestamp || '';
